import React, { useEffect, useRef, useState } from 'react';
import photo from '../../assets/img/examplePhoto.png';
import { useSelector } from 'react-redux';
import phoneBackground from '../../assets/img/phoneBackground.jpeg'
import { Battery, CellularConnection, Wifi } from '../../assets/svgs';
import smartBannerRenderer from '../../assets/js/mobligo_smart_banner';
import { validateHttps } from '../../helper/Validators';

const SmartBannerPhone = ({ notificationHeader, notificationDescription, customization, appData }) => {

  const [height, setHeight] = useState(0)
  const smartBannerRef = useRef()
  const scrollRef = useRef()

  const iframeRef = useRef()

  const myAppsData = useSelector((state) => state.myAppsSlice.localReduxData)

  const app = myAppsData?.app
  const time = new Date()
  const hours = time.getHours() < 10 ? "0" + time.getHours() : time.getHours()
  const minutes = time.getMinutes() < 10 ? "0" + time.getMinutes() : time.getMinutes()


  useEffect(() => {
    if (smartBannerRef.current) {
      smartBannerRenderer({ appImg: app.appLogo, appName: app.mobileAppName, ...appData, data: { style: customization } }, smartBannerRef.current, scrollRef.current)
    }
  }, [customization, appData])

  return (
    <div class="w-full flex justify-center p-10 ">
      <div class="w-[360px] h-[750px] bg-gradient-to-b from-gray-950 to-gray-950 border border-gray-950 rounded-[3rem] flex items-center justify-center border-box p-[0.2rem] relative shadow-[1rem_1rem_6rem_rgba(0,0,0,0.4),0_0_0.1rem_rgba(0,0,0,0.4)] overflow-hidden">
        <div class="w-1 h-20 rounded-[0_0.1rem_0.1rem_0] bg-gradient-to-r from-neutral-400 via-gray-950 to-gray-950 border-r border-gray-950 absolute -right-1 top-[30%] shadow-[2px_0_1px_rgba(0,0,0,0.2)_inset]"></div>
        <div class="w-1 h-10 rounded-[0_0.1rem_0.1rem_0] bg-gradient-to-l from-neutral-400 via-gray-950 to-gray-950 border-l border-gray-950 absolute -left-1 top-[38%] shadow-[2px_0_1px_rgba(0,0,0,0.2)_inset]"></div>
        <div class="w-1 h-10 rounded-[0_0.1rem_0.1rem_0] bg-gradient-to-l from-neutral-400 via-gray-950 to-gray-950 border-l border-gray-950 absolute -left-1 top-[28%] shadow-[2px_0_1px_rgba(0,0,0,0.2)_inset]"></div>
        <div class="w-1 h-5 rounded-[0_0.1rem_0.1rem_0] bg-gradient-to-l from-neutral-400 via-gray-950 to-gray-950 border-l border-gray-950 absolute -left-1 top-[20%] shadow-[2px_0_1px_rgba(0,0,0,0.2)_inset]"></div>

        <div class="h-full w-full bg-black rounded-[2.9rem] flex items-center justify-center border-box p-[0.5rem] relative">
          <div class="h-full w-full  bg-cover bg-center rounded-[2.4rem] flex items-center flex-col relative bg-white" >


            <div
              className=" flex flex-row w-full  items-center justify-between px-[25px] py-[10px]  "
              style={{ color: 'black' }}
            >
              <div className='text-[14px]' >{`${hours}:${minutes}`}</div>
              <div class="w-[5rem] h-[1.4rem] bg-black rounded-full"></div>

              <div className="flex shrink-0 flex-row gap-[4%] justify-end items-end">
                <CellularConnection
                  className={` w-[15.946px] 2xl:w-[20px]`}
                  style={{ fill: 'black' }}
                ></CellularConnection>
                <Wifi className={` w-[15.946px] 2xl:w-[20px] `} style={{ fill: 'black' }}></Wifi>
                <Battery className={` w-[15.946px] 2xl:w-[20px] `} style={{ fill: 'black' }}></Battery>
              </div>
            </div>

            <div className='w-full h-[655px] overflow-hidden translate-x-0' ref={smartBannerRef}>
              <div className='w-full h-auto overflow-scroll' ref={scrollRef} style={{ height: 655 }}>

                {app?.domain &&
                  <iframe ref={iframeRef} scrolling='no' className='z-[-1]' width={335.63} src={validateHttps(app?.domain) + "?isApp=true"} height={2000} />
                }
              </div>
            </div>
            <div class="w-[50%] margin-auto h-[4px] bg-black rounded-full mt-[10px]"></div>

          </div>

        </div>

      </div>
    </div>
  )
}

export default SmartBannerPhone